/** What the user picked; `system` follows the operating system. */
export type ColorScheme = 'light' | 'dark' | 'system';

const STORAGE_KEY = 'web.theme';
const SCHEMES: readonly ColorScheme[] = ['light', 'dark', 'system'];

/** Reads the stored choice, defaulting to the system one. */
export function storedColorScheme(): ColorScheme {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return SCHEMES.includes(stored as ColorScheme) ? (stored as ColorScheme) : 'system';
  } catch {
    return 'system';
  }
}

/**
 * Applies a scheme: the design tokens switch on `data-theme`, and `system`
 * removes the attribute so the media query in the tokens decides (ADR 0009).
 */
export function applyColorScheme(scheme: ColorScheme): void {
  const root = document.documentElement;
  if (scheme === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', scheme);
  try {
    localStorage.setItem(STORAGE_KEY, scheme);
  } catch {
    // Storage may be switched off; the theme still applies for this visit.
  }
}
